<template>
  <div class="main-r-wrap">
    <div class="main-r-top">
      <span
        class="main-r_top_nav"
        :class="mainStatus === 'online' && 'active'"
        @click.stop="handleClick('online')"
      >{{$t('apiDoc.在线文档')}}</span>
    </div>
    <!-- 在线文档 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'online'">
      <online-doc :onlineData="onlineData"></online-doc>
    </div>
    <!-- 在线文档 END -->
  </div>
</template>

<script>
import onlineDoc from "../components/onlineDoc";

import {OPEN_API_TEST,OPEN_API_PRO} from '@/constants/index'
const apiUrlTest = 'dce/apply';
export default {
  name:"dceApply",
  components: { onlineDoc },
  data() {
    return {
      mainStatus: "online",
      onlineData: {
        apiDesc: `${this.$t('onlineDoc.dceApplyDesc')}`,
        testApi: `${OPEN_API_TEST}/${apiUrlTest}`,
        proApi: `${OPEN_API_PRO}/${apiUrlTest}`,
        postDataList:[
          {
            title:'Headers',
            value:[
              {name: "apiAccount",type: "Number",require: "Y",normal: "",describe: `${this.$t('onlineDoc.接入方在平台的api账户标识')}`,},
              {name: "digest",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.签名字符串')}`,},
              {name: "timestamp",type: "Number",require: "Y",normal: "",describe: `${this.$t('onlineDoc.时间戳，毫秒')}`,},
            ]
          },
          {
            title:`${this.$t('onlineDoc.请求参数')}`,
            value:[
              {name: "bizContent",type: "String",require: "Y",normal: `${this.$t('onlineDoc.业务参数')}`,describe: `${this.$t('onlineDoc.业务参数模块内json格式的string类型')}`,},
            ]
          },
          {
            title:`${this.$t('onlineDoc.业务参数')}`,
            value:[
              {name: "customerCode",type: "String(30)",require: "Y",normal: "J0086474299",describe: `${this.$t('onlineDoc.客户编码（联系出货网点提供）')}`},
              {name: "sender",type: "Object",require: "Y",normal: "",describe: `${this.$t('onlineDoc.寄件信息对象')}`},
              {name: "receiver",type: "Object",require: "Y",normal: "",describe: `${this.$t('onlineDoc.收件信息对象')}`},
              {name: "items",type: "Object",require: "Y",normal: "",describe: `${this.$t('onlineDoc.dceItemsDesc')}`}
            ]
          },
          {
            title:`${this.$t('onlineDoc.sender类型说明')}`,
            value:[
              {name: "name",type: "String(32)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.dceSenderName')}`},
              {name: "taxNumber",type: "String(14)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.dceSenderTaxNumber')}`},
              {name: "postCode",type: "String(8)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.dceSenderPostCode')}`},
              {name: "prov",type: "String(60)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.dceSenderProv')}`},
              {name: "city",type: "String(60)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.dceSenderCity')}`},
              {name: "area",type: "String(60)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.dceSenderArea')}`},
              {name: "street",type: "String(60)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.dceSenderStreet')}`},
              {name: "streetNumber",type: "String(32)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.dceSenderStreetNumber')}`},
              {name: "address",type: "String(60)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.dceSenderAddress')}`},
            ]
          },
          {
            title:`${this.$t('onlineDoc.receiver类型说明')}`,
            value:[
              {name: "name",type: "String(32)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.dceReceiverName')}`},
              {name: "taxNumber",type: "String(14)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.dceReceiverTaxNumber')}`},
              {name: "postCode",type: "String(8)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.dceReceiverPostCode')}`},
              {name: "prov",type: "String(60)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.dceReceiverProv')}`},
              {name: "city",type: "String(60)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.dceReceiverCity')}`},
              {name: "area",type: "String(60)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.dceReceiverArea')}`},
              {name: "street",type: "String(60)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.dceReceiverStreet')}`},
              {name: "streetNumber",type: "String(32)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.dceReceiverStreetNumber')}`},
              {name: "address",type: "String(60)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.dceReceiverAddress')}`},
            ]
          },
          {
            title:`${this.$t('onlineDoc.items类型说明')}`,
            value:[
              {name: "itemName",type: "String(30)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.dceItemName')}`},
              {name: "number",type: "int(4)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.dceItemNumber')}`},
              {name: "itemValue",type: "String(14)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.dceItemValue')}`},
              {name: "itemNcm",type: "String(100)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.dceItemNcm')}`},
            ]
          }
        ],
        responseDataList:[
          {
            title:`${this.$t('onlineDoc.响应参数')}`,
            value:[
              { name: "code",type: "String", require: "Y",normal: "",describe: `${this.$t('onlineDoc.返回码，见附录')}`},
              {name: "msg",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.描述')}`},
              {name: "data",type: "Object",require: "Y",normal: "",describe: `${this.$t('onlineDoc.业务数据')}`},
            ]
          },
          {
            title:`${this.$t('onlineDoc.data类型说明')}`,
            value:[
              {name: "dceId",type: "String",require: "Y",normal: "35260542584754000267990020000013931307653305",describe: `${this.$t('onlineDoc.dceId')}`},
              {name: "recordTime",type: "String",require: "Y",normal: "2026-05-12 03:25:37",describe: `${this.$t('onlineDoc.dceRecordTime')}`},
              {name: "invoiceMoney",type: "String",require: "Y",normal: "17.88",describe: `${this.$t('onlineDoc.dceInvoiceMoney')}`},
              {name: "failReason",type: "String",require: "N",normal: "",describe: `${this.$t('onlineDoc.dceFailReason')}`},
            ]
          }
        ],
        requestCode: `Header：
apiAccount=292508153084379141
digest=5EJcbtDRjOvSj+uGThytpA==
timestamp=1638429847416

Body：
bizContent={
    "receiver": {
        "area": "Centro",
        "address": "Rua do Ouvidor, 56 - Centro",
        "city": "Rio de Janeiro",
        "streetNumber": "56",
        "street": "Rua do Ouvidor",
        "name": "Maria Santos",
        "taxNumber": "64070098000136",
        "postCode": "20040020",
        "prov": "RJ"
    },
    "sender": {
        "area": "Bela Vista",
        "address": "Rua Augusta, 1234 - Bela Vista",
        "city": "Sao Paulo",
        "streetNumber": "1234",
        "street": "Rua Augusta",
        "name": "Joao Silva",
        "taxNumber": "64070098000136",
        "postCode": "01310100",
        "prov": "SP"
    },
    "customerCode": "J0086024185",
    "items": [
        {
            "number": 1,
            "itemName": "Celular Smartphone",
            "itemValue": "111.00",
            "itemNcm": "97012900"
        },
        {
            "number": 2,
            "itemName": "Capa Protetora",
            "itemValue": "25.00",
            "itemNcm": "97012900"
        }
    ]
}`,
        responseCode: {"code":"1","msg":"请求成功","data":{"dceId":"35260542584754000267990020000013931307653305","recordTime":"2026-05-12 03:25:37","invoiceMoney":null,"failReason":null}},
        errcodeJson: []
      },
    };
  },
  created() {},
  methods: {
    handleClick(status) {
      this.mainStatus = status;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/apiTest.scss";
</style>
